// extracted by mini-css-extract-plugin
export default {"container":"PharmacyOrdersTab_container__I1Xq7"};